module.exports = __webpack_public_path__ + "media/images/icons/outlined/aim-ba84aae889a9fd3ce8eaf25d5550a045.svg";